import request, { handleSessionExpired } from '@/utils/request'
import URL from '@/api/urlTranslator'

// 上传账单文件（只支持 Excel：.xlsx / .xls）
export function uploadBillFile(formData) {
  return request({
    url: URL.recon.upload,
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 供应商下拉列表（IF_SUPPLIER=true，pageSize=10000 全量）
export function searchSuppliers(params) {
  return request({
    url: URL.recon.suppliers,
    method: 'get',
    params
  })
}

// 元数据（账单类型/任务状态/解析状态枚举）
export function getReconMeta() {
  return request({
    url: URL.recon.meta,
    method: 'get'
  })
}

// 创建对账任务
export function createReconTask(data) {
  return request({
    url: URL.recon.createTask,
    method: 'post',
    data
  })
}

// 重复检查
export function checkReconDuplicate(data) {
  return request({
    url: URL.recon.duplicateCheck,
    method: 'post',
    data
  })
}

// 任务分页
export function queryReconTaskPage(data) {
  return request({
    url: URL.recon.taskPage,
    method: 'post',
    data
  })
}

// 任务详情
export function getReconTaskDetail(taskUuid) {
  return request({
    url: `${URL.recon.taskDetail}/${taskUuid}`,
    method: 'get'
  })
}

// 作废对账任务
export function invalidateReconTask(taskUuid, reason) {
  return request({
    url: `${URL.recon.taskDetail}/${taskUuid}/invalidate`,
    method: 'post',
    data: { reason }
  })
}

// 重新解析
export function reparseReconTask(taskUuid) {
  return request({
    url: `${URL.recon.taskDetail}/${taskUuid}/reparse`,
    method: 'post'
  })
}

// 匹配结果列表（一个提单号/业务单号一行）
export function listMatchRecords(taskUuid) {
  return request({
    url: `${URL.recon.match}/${taskUuid}/records`,
    method: 'get'
  })
}

// 匹配结果详情（供应商费用明细 + 系统费用快照）
export function getMatchRecordDetail(recordUuid) {
  return request({
    url: `${URL.recon.match}/records/${recordUuid}/detail`,
    method: 'get'
  })
}

// 总额接受匹配记录
export function totalAcceptMatchRecord(recordUuid, reason) {
  return request({
    url: `${URL.recon.match}/records/${recordUuid}/total-accept`,
    method: 'post',
    data: { reason }
  })
}

// 人工重新匹配
export function rematchReconTask(taskUuid) {
  return request({
    url: `${URL.recon.match}/${taskUuid}/rematch`,
    method: 'post'
  })
}

// 强制接受费用明细差异
export function forceAcceptMatchDetail(detailUuid, reason) {
  return request({
    url: `${URL.recon.match}/details/${detailUuid}/force-accept`,
    method: 'post',
    data: { reason }
  })
}

// 人工关联供应商费用与系统费用快照，并重新计算该行差额
export function bindMatchDetailSystemCharge(detailUuid, data) {
  return request({
    url: `${URL.recon.match}/details/${detailUuid}/bind-system-charge`,
    method: 'post',
    data
  })
}

// 解除人工关联，恢复供应商费用与系统费用的待处理状态
export function unbindMatchDetailSystemCharge(detailUuid) {
  return request({
    url: `${URL.recon.match}/details/${detailUuid}/unbind-system-charge`,
    method: 'post'
  })
}

// 发起费用明细争议
export function disputeMatchDetail(detailUuid, data, forbidAlert) {
  return request({
    url: `${URL.recon.match}/details/${detailUuid}/dispute`,
    method: 'post',
    data,
    forbidAlert
  })
}

// 首页统计卡片（待处理/已完成/争议中/异常未匹配）
export function getReconDashboardStats() {
  return request({
    url: URL.recon.dashboardStats,
    method: 'get'
  })
}

// 完成前预检查
export function preCheckComplete(taskUuid) {
  return request({
    url: `${URL.recon.taskDetail}/${taskUuid}/complete/pre-check`,
    method: 'get'
  })
}

// 执行对账完成
export function completeReconTask(taskUuid) {
  return request({
    url: `${URL.recon.taskDetail}/${taskUuid}/complete`,
    method: 'post'
  })
}

// 导出费用比对 Excel（服务端生成，responseType blob）
export function exportReconComparison(taskUuid) {
  return request({
    url: `${URL.recon.taskDetail}/${taskUuid}/export`,
    method: 'get',
    responseType: 'blob',
    params: { _t: Date.now() },
    passthroughBlob: true
  }).then(validateExportResponse)
}

function validateExportResponse(response) {
  const blob = response && response.data
  if (!blob || typeof Blob === 'undefined' || !(blob instanceof Blob) || !blob.size) {
    return Promise.reject('导出失败，请稍后重试')
  }
  const disposition = response.headers && response.headers['content-disposition']
  if (disposition) {
    return response
  }
  return blob.text().then(text => {
    const trimmed = (text || '').trim()
    try {
      const parsed = JSON.parse(trimmed)
      if (isSessionExpired(parsed)) {
        handleSessionExpired()
      }
      return Promise.reject(
        (parsed.errors && parsed.errors[0] && parsed.errors[0].message) || parsed.message || '导出失败，请稍后重试'
      )
    } catch (e) {
      return Promise.reject('导出失败，请稍后重试')
    }
  })
}

function isSessionExpired(result) {
  return result && (result.code === '0001' ||
    (Array.isArray(result.errors) && result.errors.some(error => error && error.code === '0001')))
}
